import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    directorsAndShareholders: {
        id: '_.your_company.directors_and_shareholders',
        defaultMessage: 'Directors and Shareholders'
    },
    directorsAndShareholdersIntroText: {
        id: '_.your_company.directors_and_shareholders_intro_text',
        defaultMessage:
            'We need details of all the directors and major shareholders with 25% or more shares in your business, as we’re required to run anti-money laundering checks (don’t worry, this won’t affect anyone’s credit score).'
    },
    addAnotherPerson: {
        id: '_.your_company.add_another_person',
        defaultMessage: 'Add another person'
    }
});
